module.exports = __webpack_public_path__ + "img/bg.29695998.png";